<template>
  <div class="home_page">
    <div class="create_order">
      <div class="order_body">
        <el-form ref="dataForm" label-width="90px" label-position="left">
          <!-- 地址 -->
          <div class="addressList_oreder">
            <div class="addTitle_box flex-st">
              <div class="addTitle_label">收货地址:</div>
              <div class="addTitle_btn" @click="addAddress">
                <i class="el-icon-circle-plus-outline"></i>新增收货地址
              </div>
              <div
                class="addTitle_btn"
                @click="togMore"
                v-if="addressList.length > 3"
              >
                <span v-if="!showAddressVisible"
                  ><i class="el-icon-caret-top"></i>显示全部</span
                >
                <span v-if="showAddressVisible"
                  ><i class="el-icon-caret-bottom"></i>收起</span
                >
              </div>
            </div>
            <div
              class="addList_box flex-sp"
              :class="{
                addList_box_active: params.orderAddressId == item.userAddressId
              }"
              v-for="(item, index) in addressListLast"
              :key="index"
            >
              <div
                class="addList_left"
                @click.stop="addressChangeHandle(item.userAddressId)"
              >
                <div class="addList_left_title flex-st">
                  <span class="addList_left_name">{{
                    item.receiveGoodsPerson
                  }}</span>
                  <span class="addList_left_phone">{{
                    item.receiveGoodsPhone
                  }}</span>
                  <span class="addList_left_tag" v-if="item.defaultAddress"
                    >默认</span
                  >
                </div>
                <div class="addList_left_address flex-st">
                  <i class="el-icon-location-outline"></i>
                  <div class="ell_one">
                    {{ item.province }}-{{ item.city }}-{{ item.area }}-{{
                      item.address
                    }}
                  </div>
                </div>
              </div>
              <div class="addList_right">
                <el-button
                  type="text"
                  v-if="!item.defaultAddress"
                  @click="setDefaultAddress(item)"
                  >设为默认地址</el-button
                >
                <el-button
                  type="text"
                  style="color:#333;"
                  v-if="item.defaultAddress"
                  >默认地址</el-button
                >
                <el-button type="text" @click="addressEditHandle(item)"
                  >编辑</el-button
                >
                <el-button type="text" @click="addressDeleteHandle(item)"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
          <!-- 发票 -->
          <div class="invoice_order margin-top">
            <div class="invoice_title flex-st">
              <div class="invoice_title_label">发票信息：</div>
              <div class="invoice_title_btn" @click="invoiceAddHandle">
                <i class="el-icon-circle-plus-outline"></i>新增发票
              </div>
            </div>
            <div class="invoice_list_box flex-st">
              <div
                class="invoice_list_item"
                :class="{
                  invoice_list_item_active: index === InvoiceActiveInex
                }"
                v-for="(item, index) in payInvoiceInfoList"
                @click="selectInvoice(index)"
                :key="index"
              >
                <span v-show="item.invoiceType == 20">增值税专用发票</span>
                <span v-show="item.invoiceType == 10">增值税普通发票</span>
              </div>
              <div
                class="invoice_list_item"
                :class="{
                  invoice_list_item_active: 100001 == InvoiceActiveInex
                }"
                @click="selectInvoice(100001)"
              >
                <span>暂不开发票</span>
              </div>
            </div>
            <div
              class="invoice_Info flex-st"
              v-if="
                payInvoiceInfoList.length > 0 && InvoiceActiveInex != '100001'
              "
            >
              <div class="invoice_Info_left flex-st">
                <div class="invoice_Info_item flex-st">
                  <div class="invoice_item_label">发票抬头:</div>
                  <div class="invoice_item_content ell_one">
                    {{ payInvoiceInfoList[InvoiceActiveInex].companyName }}
                    <span
                      v-if="
                        payInvoiceInfoList[InvoiceActiveInex].defaultFlag ===
                          '10'
                      "
                      class="default-flag"
                      >默认</span
                    >
                  </div>
                </div>
                <div class="invoice_Info_item flex-st">
                  <div class="invoice_item_label">开户行:</div>
                  <div class="invoice_item_content ell_one">
                    {{ payInvoiceInfoList[InvoiceActiveInex].openingBank }}
                  </div>
                </div>
                <div class="invoice_Info_item flex-st">
                  <div class="invoice_item_label">税务登记证号:</div>
                  <div class="invoice_item_content ell_one">
                    {{ payInvoiceInfoList[InvoiceActiveInex].taxpayerIdentity }}
                  </div>
                </div>
                <div class="invoice_Info_item flex-st">
                  <div class="invoice_item_label">开户账号:</div>
                  <div class="invoice_item_content ell_one">
                    {{ payInvoiceInfoList[InvoiceActiveInex].bankAccountNo }}
                  </div>
                </div>
                <div class="invoice_Info_item flex-st">
                  <div class="invoice_item_label">注册场所地址:</div>
                  <div class="invoice_item_content ell_two">
                    {{ payInvoiceInfoList[InvoiceActiveInex].companyAddress }}
                  </div>
                </div>
                <div class="invoice_Info_item flex-st">
                  <div class="invoice_item_label">电话:</div>
                  <div class="invoice_item_content ell_one">
                    {{ payInvoiceInfoList[InvoiceActiveInex].companyPhone }}
                  </div>
                </div>
              </div>
              <div class="invoice_Info_right">
                <el-button
                  type="text"
                  @click="
                    invoiceEditHandle(payInvoiceInfoList[InvoiceActiveInex])
                  "
                  >编辑发票</el-button
                >
                <el-button
                  type="text"
                  @click="
                    invoiceDeleteHandle(payInvoiceInfoList[InvoiceActiveInex])
                  "
                  >删除发票</el-button
                >
              </div>
            </div>
          </div>
          <el-row class="goods_box">
            <div class="goods_title">商品信息：</div>
            <el-col :span="24">
              <el-table
                ref="goodsTable"
                :data="
                  dataJson.commodityDetails.slice(
                    (goodsPage - 1) * 10,
                    goodsPage * 10
                  )
                "
                style="width: 1200px"
                size="small"
                border
              >
                <el-table-column prop="skuCode" width="400" label="商品信息">
                  <template slot-scope="{ row }">
                    <div class="flex-sp goods_info">
                      <div class="img-box">
                        <img :src="row.fileUrls" alt="" />
                      </div>
                      <div class="goods_info_title">
                        <div class="ell_two">
                          {{ row.commodityName }}
                        </div>
                        <div>商品编号:{{ row.skuCode }}</div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="commodityModel"
                  width="200"
                  label="产品型号"
                ></el-table-column>
                <el-table-column prop="commodityPrice" label="单价（元）">
                  <template slot-scope="{ row }">
                    <span>{{ row.commodityPrice | formatePrice }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="commodityNum"
                  label="数量"
                  width="80"
                ></el-table-column>
                <el-table-column prop="expressFee" label="运费" width="">
                  <template slot-scope="{ row }">
                    <span>{{ row.expressFee | formatePrice }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="小计（元）" width="">
                  <template slot-scope="{ row }">
                    <span>{{
                      (row.commodityPrice * row.commodityNum + row.expressFee)
                        | formatePrice
                    }}</span>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 商品分页 -->
              <el-pagination
                :current-page="goodsPage"
                :page-size="10"
                v-show="
                  dataJson.commodityDetails &&
                    dataJson.commodityDetails.length > 10
                "
                :total="
                  dataJson.commodityDetails
                    ? dataJson.commodityDetails.length
                    : 0
                "
                layout="total, prev, pager, next, jumper"
                @current-change="changeGoodsPage"
              >
              </el-pagination>
              <!-- 订单总金额  运费-->
              <el-row style="padding:24px 0 32px;">
                <el-col :span="5" :offset="19" style="margin-top:10px">
                  <span
                    >总金额：<span style="color:red"
                      ><span>￥</span
                      >{{ dataJson.orderMoney | formatePrice }}</span
                    ></span
                  >
                </el-col>
                <el-col :span="5" :offset="19" style="margin-top:10px">
                  <span
                    >运费：<span style="color:red"
                      ><span>￥</span
                      >{{ dataJson.expressFee | formatePrice }}</span
                    ></span
                  >
                </el-col>
              </el-row>
              <el-row
                style="background-color:#ebebeb; height:64px"
                class="flex-sp"
                v-if="dataForm.promotion !== 1"
              >
                <el-col
                  :span="18"
                  :offset="0"
                  style="margin-top:12px;text-align:right;"
                >
                  <div>
                    应付总额：<span style="color:red"
                      ><span>￥</span>{{ shouldPay | formatePrice }}</span
                    >
                  </div>
                  <div v-if="dataForm.promotion !== 1">
                    运费：<span style="color:red"
                      ><span>￥</span
                      >{{ dataJson.expressFee | formatePrice }}</span
                    >
                  </div>
                </el-col>
                <el-col :span="1"> </el-col>
                <el-col
                  :span="5"
                  v-show="distributionFlag && dataJson.commodityDetails.length"
                >
                  <el-button
                    class="submit_btn"
                    type="primary"
                    :loading="buttonLoading"
                    @click="submit"
                    >提交预订单</el-button
                  >
                </el-col>
                <el-col :span="4" v-show="!distributionFlag">
                  <el-button type="primary" class="submit_btn" disabled
                    >不在配送区域内</el-button
                  >
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="19"> &nbsp; </el-col>
                <el-col :span="5">
                  <div class="desc">
                    提交后将预订单信息同步至贵司，<br />完成内部确认后方能下单开始交付
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <!-- 编辑收货地址 -->
    <el-dialog
      title="收货地址"
      :visible.sync="editAddressVisible"
      width="1190px"
      :before-close="handleClose2"
    >
      <div class="addArea" v-if="editAddressInfo">
        <h2 class="addTitle">编辑收货地址</h2>
        <div class="add_form">
          <el-form
            ref="editAddressInfo"
            label-width="198px"
            :model="editAddressInfo"
            :rules="addressRule"
            :disabled="buttonLoading"
            label-position="right"
          >
            <el-form-item label="地址信息：" prop="proCityArea">
              <el-cascader
                :options="region"
                clearable
                :placeholder="
                  (editAddressInfo.proCityArea &&
                    editAddressInfo.proCityArea.join(' / ')) ||
                  '请选择'
                "
                :props="props"
                class="input_width"
                v-model="editAddressInfo.proCityArea"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="详细地址：" prop="address">
              <el-input
                v-model="editAddressInfo.address"
                placeholder="请输入详细地址"
                :maxlength="200"
              ></el-input>
            </el-form-item>
            <el-form-item label="收货人姓名：" prop="receiveGoodsPerson">
              <el-input
                v-model="editAddressInfo.receiveGoodsPerson"
                class="input_width"
                placeholder="请输入收货人姓名"
                :maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号码：" prop="receiveGoodsPhone">
              <div class="last_row">
                <el-input
                  v-model="editAddressInfo.receiveGoodsPhone"
                  class="input_width"
                  placeholder="请输入手机号码"
                  :maxlength="50"
                ></el-input>
                <el-checkbox
                  v-model="editAddressInfo.defaultAddress"
                  text-color="#333333"
                  fill="#1D65A8"
                  class="defaultbox"
                >
                  设为默认收货地址
                </el-checkbox>
              </div>
            </el-form-item>
          </el-form>
          <div class="addTitle" style="height: 2px;">&nbsp;</div>
          <div
            @click="handleAddressSaved"
            class="saveAdd"
            v-loading="buttonLoading"
          >
            保存地址
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 删除提示 -->
    <el-dialog
      title=""
      :visible.sync="addressDeleteVisible"
      width="30%"
      :before-close="
        () => {
          addressDeleteVisible = false
        }
      "
    >
      <span>{{$t('message.deleteAddress')}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="addressDeleteVisible = false"
          :loading="buttonLoading"
          >{{$t('cancel')}}</el-button
        >
        <el-button
          type="primary"
          @click="confirmAddDelete"
          :loading="buttonLoading"
          >{{$t('confirm')}}</el-button
        >
      </span>
    </el-dialog>
    <!-- 新增发票弹窗 -->
    <el-dialog
      title="发票信息"
      :visible.sync="invoiceVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        :model="invoiceForm"
        :rules="invoiceFormRules"
        ref="invoiceForm"
        label-position="right"
      >
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="发票类型：" prop="invoiceType">
              <el-radio-group v-model="invoiceForm.invoiceType">
                <el-radio label="10">普通发票</el-radio>
                <el-radio label="20">专用发票</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开票对象：" prop="invoiceObjType">
              <el-radio-group v-model="invoiceForm.invoiceObjType">
                <el-radio label="10">个人</el-radio>
                <el-radio label="20">单位</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="发票类型：" prop="invoiceType">
              <el-checkbox v-model="invoiceForm.flagAdd">
                默认发票
              </el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发票抬头" prop="companyName">
              <el-input
                v-model="invoiceForm.companyName"
                :maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税务登记证号" prop="taxpayerIdentity">
              <el-input
                v-model="invoiceForm.taxpayerIdentity"
                maxlength="50"
                placeholder=""
                @input="
                  invoiceForm.taxpayerIdentity = invoiceForm.taxpayerIdentity.replace(
                    /[^A-Za-z0-9]/g,
                    ''
                  )
                "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="基本开户账号"
              prop="bankAccountNo"
              :rules="
                invoiceForm.invoiceType === '20'
                  ? invoiceFormRules.bankAccountNo
                  : [{ required: false, message: '', trigger: 'blur' }]
              "
            >
              <el-input
                v-model="invoiceForm.bankAccountNo"
                :maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="注册固定电话"
              prop="companyPhone"
              :rules="
                invoiceForm.invoiceType === '20'
                  ? invoiceFormRules.companyPhone
                  : [{ required: false, message: '', trigger: 'blur' }]
              "
            >
              <el-input
                v-model="invoiceForm.companyPhone"
                :maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="开户银行名称"
              prop="openingBank"
              :rules="
                invoiceForm.invoiceType === '20'
                  ? invoiceFormRules.openingBank
                  : [{ required: false, message: '', trigger: 'blur' }]
              "
            >
              <el-input
                v-model="invoiceForm.openingBank"
                :maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="注册场所地址"
              prop="companyAddress"
              :rules="
                invoiceForm.invoiceType === '20'
                  ? invoiceFormRules.companyAddress
                  : [{ required: false, message: '', trigger: 'blur' }]
              "
            >
              <el-input
                v-model="invoiceForm.companyAddress"
                :maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发票收货人" prop="consignee">
              <el-input
                v-model="invoiceForm.consignee"
                :maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票收货人电话" prop="contactInformation">
              <el-input
                v-model="invoiceForm.contactInformation"
                :maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发票邮寄地址" prop="mailingAddress">
              <el-input
                v-model="invoiceForm.mailingAddress"
                :maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeInviceHandle()" :loading="buttonLoading"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="invoiceSaveHandle()"
          :loading="buttonLoading"
          >保 存</el-button
        >
      </div>
    </el-dialog>
    <company-add
      ref="companyAdd"
      v-if="addCompanyVisible"
      :jumpRoute="false"
    ></company-add>
  </div>
</template>
<script>
import debounce from 'lodash/debounce'
import validate from '@/utils/validate'
import Cookies from 'js-cookie'
import { getAccessToken } from '@/utils/userInfo'
import CompanyAdd from '@/views/modules/personalCenter/organization/company-add'
export default {
  data () {
    return {
      distributionFlag: false, // 是否在配送区域内
      buttonLoading: false, // 加载中
      // 生成订单参数
      params: {
        orderSource: '',
        companyId: '',
        companyName: '',
        addressId: '',
        userId: '',
        commodityDetails: [
          // {
          //   skuId: '4324476016296734720',
          //   supId: '2324476013062926336',
          //   commodityNum: 2
          // }
        ], // 购买商品，立即购买也使用此参数
        orderAddressId: '' // 切换发货地址计算运费
      },
      // 生成订单返回参数
      dataJson: {
        promotion: 1,
        commodityDetails: [],
        payMoney: 0,
        expressFee: 0, // 运费
        discountAmount: 0
      },
      // 表单提交参数
      dataForm: {
        revisionPrice: false, // 是否改价
        leaveMsg: '', // 改价留言
        outStock: '10',
        // orderSource: '', // 订单类型
        // shoppingCart: {}, // 商品列表
        // shoppingCartFormList: [], // 商品列表
        invoiceInfoId: '', // 发票Id
        // addressId: '', // 公司地址id
        contractType: '20', // 合同类型(10 自定义合同,20 默认合同,30 无需合同)
        contractUrl: '', // 合同url
        orderRemarks: '', // 订单备注
        fullAmount: true // 是否全款，false否，true是
      },
      goodsPage: 1,
      // 地址
      region: [],
      props: {
        label: 'name',
        value: 'name',
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node
          // 防止过载
          if (node.loaded) {
            resolve([])
            return
          }
          if (level === 1) {
            // 切换省
            this.getCity(data.codeP)
              .then((res) => {
                resolve(res)
              })
              .catch(() => {
                resolve([])
              })
          }
          if (level === 2) {
            // 切换市
            this.getArea(data.codeC)
              .then((res) => {
                resolve(res)
              })
              .catch(() => {
                resolve([])
              })
          }
        }
      },
      addressList: [], // 地址列表 全部
      addressListLast: [], // 地址列表 3条
      showAddressVisible: false,
      editAddressVisible: false, // 编辑地址弹框
      editAddressInfo: null,
      addressDeleteVisible: false, // 删除地址弹框
      addressDeleteId: '',
      // 发票
      payInvoiceInfoList: [],
      InvoiceActiveInex: 100001, // 选中发票下标 暂不开具发票
      invoiceVisible: false,
      // 发票对象
      invoiceForm: {
        flagAdd: false,
        invoiceId: '',
        invoiceObjType: '10', // 开票对象类型 10 个人 20 单位
        invoiceObjId: '10', // 开票对象10 用户id 20 公司id
        invoiceType: '10', // 开票类型10 普通发票 20 增值税发票
        companyName: '', // 开票公司名称(发票抬头)
        taxpayerIdentity: '', // 纳税人识别号
        companyAddress: '', // 公司地址
        companyPhone: '', // 联系电话
        openingBank: '', // 开户行
        bankAccountNo: '', // 开户行账号
        defaultFlag: '10', //  缺省标识 10 默认 20 非默认
        remarks: '',
        mailingAddress: '', // 发票邮寄地址
        consignee: '', // 收货人
        contactInformation: '' // 收货人联系方式
      },
      // 上传
      actionUrl: window.SITE_CONFIG['apiURL'] + '/help/fileupload/sys/v2/upload',
      upLoadHeaders: {
        Authorization: 'Bearer ' + getAccessToken()
      },
      contractIds: [], // 要删除的合同编号
      addCompanyVisible: false // 企业账号 dialog
    }
  },
  computed: {
    shouldPay () {
      // 应付金额
      let shouldPay = this.dataJson.orderMoney + this.dataJson.expressFee
      return shouldPay
    },
    addressRule () {
      return {
        proCityArea: [
          {
            required: true,
            type: 'array',
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        address: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        receiveGoodsPerson: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        receiveGoodsPhone: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          },
          { validator: validate.validateMobile, trigger: 'blur' }
        ]
      }
    },
    invoiceFormRules () {
      return {
        companyPhone: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        openingBank: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        companyName: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        taxpayerIdentity: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        bankAccountNo: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        companyAddress: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  components: {
    CompanyAdd
  },
  created () {
    this.getPostParams()
  },
  mounted () {
    this.addCompanyVisible = false
    this.getProvince()
    this.getOrderInfo()
    this.getaddressDataList()
  },
  methods: {
    // 整理生成订单相关参数
    getPostParams () {
      let queryInfo = ''
      if (this.$route.query.orderSource === '10') {
        // 购物车下单
        queryInfo = this.$route.query.shoppingCartFormList
          ? JSON.parse(this.$route.query.shoppingCartFormList)
          : ''
      } else if (this.$route.query.orderSource === '20') {
        // 立即下单
        queryInfo = this.$route.query.shoppingCart
          ? JSON.parse(this.$route.query.shoppingCart)
          : ''
      }
      queryInfo.forEach((item, index) => {
        queryInfo[index] = {
          skuId: item.goodsSkuId,
          spuId: item.goodsSpuId,
          commodityNum: item.goodsNum
        }
      })
      this.params.commodityDetails = queryInfo
    },
    // 设置默认地址
    setDefaultAddress (val) {
      this.$http
        .post(
          `/front/consumer/user/address/setDefaultAddress/${val.userAddressId}`,
          this.params
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.getaddressDataList()
          }
        })
    },
    // 发票选择
    selectInvoice (index) {
      this.InvoiceActiveInex = index
    },
    // 地址收起展开
    togMore () {
      this.showAddressVisible = !this.showAddressVisible
      if (this.showAddressVisible) {
        this.addressListLast = this.addressList
      } else {
        this.addressListLast = this.addressList.slice(0, 3)
      }
    },
    // 获取订单详情
    getOrderInfo () {
      this.payInvoiceInfoList = []
      this.dataJson = {
        promotion: 1,
        commodityDetails: [],
        payMoney: 0,
        expressFee: 0, // 运费
        discountAmount: 0
      }
      this.goodsPage = 1
      this.$http
        .post(`/openapi/punchoutOrder/generatePunchoutOrder`, this.params)
        .then(({ data: res }) => {
          if (res.resultCode !== '0') {
            return false
          }
          let data = res.result
          this.params.companyId = data.companyId
          this.params.companyName = data.companyName
          this.params.userId = data.userId
          let addressId = ''
          if (data.sysUserAddressVos && data.sysUserAddressVos.length) {
            let address = data.sysUserAddressVos.find(item => {
              return item.defaultAddress === true
            })
            if (!address) {
              addressId = data.sysUserAddressVos[0].userAddressId
            } else {
              addressId = address.userAddressId
            }
          }
          this.params.orderAddressId = addressId
          this.dataJson = data
          this.payInvoiceInfoList = this.dataJson.payOrderInvoiceVos || []
          // this.goodsTableData = data.payOrderItemVoList
          if (data.commodityDetails && data.commodityDetails.length) {
            this.distributionFlag = data.commodityDetails.every(item => {
              // distribution  =2支持  =1 不支持 3面议
              return item.distribution && item.distribution !== 1
            })
          } else {
            this.distributionFlag = false
          }
        })
    },
    changeGoodsPage (page) {
      this.goodsPage = page
    },
    // 更改选中的地址
    addressChangeHandle (addressId) {
      // console.log(addressId)
      // if (this.params.orderAddressId !== addressId) {
      this.params.orderAddressId = addressId
      this.refushOrder()
      // }
    },
    // 由于切换地址造成运费及相关价格改变等
    refushOrder () {
      this.payInvoiceInfoList = []
      this.dataJson = {
        promotion: 1,
        commodityDetails: [],
        payMoney: 0,
        expressFee: 0, // 运费
        discountAmount: 0
      }
      this.goodsPage = 1
      this.$http
        .post(`/openapi/punchoutOrder/generatePunchoutOrder`, this.params)
        .then(({ data: res }) => {
          if (res.resultCode !== '0') {
            return false
          }
          let data = res.result
          this.params.companyId = data.companyId
          this.params.companyName = data.companyName
          this.payInvoiceInfoList = data.payOrderInvoiceVos || []
          // this.params.orderAddressId = addressId
          this.dataJson = data
          if (data.commodityDetails && data.commodityDetails.length) {
            this.distributionFlag = data.commodityDetails.every(item => {
              // distribution  =2支持  =1 不支持 3面议
              return item.distribution && item.distribution !== 1
            })
          } else {
            this.distributionFlag = false
          }
        })
    },
    // 关闭弹窗  地址
    handleClose2 () {
      this.editAddressVisible = false
      this.editAddressInfo = {
        companyId: '', // 当前地址对应的公司Id
        userAddressId: '',
        proCityArea: [],
        address: '', // 地址
        orderAddress: '', // 省市区详细地址拼接
        province: '',
        city: '',
        area: '',
        receiveGoodsPerson: '', // 收货人
        receiveGoodsPhone: '', // 收货联系电话
        defaultAddress: false, // 是否默认地址
        used: true // 是否可用
      }
    },
    // 添加地址
    addAddress () {
      this.editAddressInfo = {
        companyId: this.params.companyId, // 当前地址对应的公司Id
        userAddressId: '',
        proCityArea: [],
        address: '', // 地址
        orderAddress: '', // 省市区详细地址拼接
        province: '',
        city: '',
        area: '',
        receiveGoodsPerson: '', // 收货人
        receiveGoodsPhone: '', // 收货联系电话
        defaultAddress: false, // 是否默认地址
        used: true // 是否可用
      }
      this.editAddressVisible = true
    },
    // 编辑地址
    addressEditHandle (row) {
      this.editAddressInfo = {
        companyId: row.companyId, // 当前地址对应的公司Id
        userAddressId: row.userAddressId,
        proCityArea: [],
        address: row.address, // 地址
        orderAddress: '', // 省市区详细地址拼接
        province: '',
        city: '',
        area: '',
        receiveGoodsPerson: row.receiveGoodsPerson, // 收货人
        receiveGoodsPhone: row.receiveGoodsPhone, // 收货联系电话
        defaultAddress: row.defaultAddress, // 是否默认地址
        used: row.used // 是否可用
      }
      if (row.province) {
        this.editAddressInfo.proCityArea.push(row.province)
        if (row.city) {
          this.editAddressInfo.proCityArea.push(row.city)
          if (row.area) {
            this.editAddressInfo.proCityArea.push(row.area)
          }
        }
      }
      this.editAddressVisible = true
    },
    // 保存地址
    handleAddressSaved: debounce(
      function () {
        this.$refs['editAddressInfo'].validate(valid => {
          if (!valid) {
            return false
          }
          this.editAddressInfo.province = this.editAddressInfo.proCityArea[0]
          this.editAddressInfo.city = this.editAddressInfo.proCityArea[1]
          this.editAddressInfo.area = this.editAddressInfo.proCityArea[2]
          this.editAddressInfo.orderAddress =
            this.editAddressInfo.proCityArea.join('') +
            this.editAddressInfo.address
          this.$http
            .post(
              `/front/consumer/user/address/${
                this.editAddressInfo.userAddressId
                  ? 'updateUserAddress'
                  : 'addUserAddress'
              }`,
              this.editAddressInfo
            )
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return false
              }
              this.$message.success(res.message)
              this.handleClose2()
              this.getaddressDataList()
              // this.editAddressVisible = false
            })
            .catch(() => {})
        })
      },
      1000,
      { leading: true, trailing: false }
    ),
    // 删除地址
    addressDeleteHandle (row) {
      this.addressDeleteId = row.userAddressId
      this.addressDeleteVisible = true
    },
    // 确认删除地址
    confirmAddDelete () {
      if (!this.addressDeleteId) {
        this.addressDeleteVisible = false
        return false
      }
      this.$http
        .post(`/front/consumer/user/address/deleteById/${this.addressDeleteId}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.addressDeleteVisible = false
          this.getaddressDataList()
        })
    },
    // 获取用户地址列表
    getaddressDataList () {
      this.$request
        .get(
          `/front/consumer/user/address/userAddressList?companyId=${this.params.companyId}`
        )
        .then(res => {
          this.addressList = res || []
          if (this.params.orderAddressId) {
            let address = this.addressList.find(item => {
              return item.userAddressId === this.params.orderAddressId
            })
            if (!address) {
              this.params.orderAddressId = ''
            }
          }
          if (!this.params.orderAddressId && this.addressList.length) {
            let address = this.addressList.find(item => {
              return item.defaultAddress === true
            })
            if (address) {
              this.params.orderAddressId = address.userAddressId
            } else {
              this.params.orderAddressId = this.addressList[0].userAddressId
              this.addressChangeHandle(this.addressList[0].userAddressId)
            }
          }
          this.addressListLast = this.addressList.slice(0, 3)
        })
        .catch()
    },
    // 新增发票
    invoiceAddHandle () {
      this.invoiceVisible = true
      if (this.$refs['invoiceForm']) {
        this.$refs['invoiceForm'].resetFields()
      }
      this.invoiceForm = {
        flagAdd: false,
        invoiceId: '',
        invoiceObjType: '10', // 开票对象类型 10 个人 20 单位
        invoiceObjId: '10', // 开票对象10 用户id 20 公司id
        invoiceType: '10', // 开票类型10 普通发票 20 增值税发票
        companyName: '', // 开票公司名称(发票抬头)
        taxpayerIdentity: '', // 纳税人识别号
        companyAddress: '', // 公司地址
        companyPhone: '', // 联系电话
        openingBank: '', // 开户行
        bankAccountNo: '', // 开户行账号
        defaultFlag: '10', //  缺省标识 10 默认 20 非默认
        remarks: '',
        mailingAddress: '', // 发票邮寄地址
        consignee: '', // 收货人
        contactInformation: '' // 收货人联系方式
      }
    },
    // 编辑发票
    invoiceEditHandle (row) {
      this.invoiceVisible = true
      if (this.$refs['invoiceForm']) {
        this.$refs['invoiceForm'].resetFields()
      }
      this.invoiceForm = {
        flagAdd: row.defaultFlag === '10',
        invoiceId: row.invoiceId,
        invoiceObjType: row.invoiceObjType, // 开票对象类型 10 个人 20 单位
        invoiceObjId: row.invoiceObjId, // 开票对象10 用户id 20 公司id
        invoiceType: row.invoiceType, // 开票类型10 普通发票 20 增值税发票
        companyName: row.companyName, // 开票公司名称(发票抬头)
        taxpayerIdentity: row.taxpayerIdentity, // 纳税人识别号
        companyAddress: row.companyAddress, // 公司地址
        companyPhone: row.companyPhone, // 联系电话
        openingBank: row.openingBank, // 开户行
        bankAccountNo: row.bankAccountNo, // 开户行账号
        defaultFlag: row.defaultFlag, //  缺省标识 10 默认 20 非默认
        remarks: row.remarks,
        mailingAddress: row.mailingAddress, // 发票邮寄地址
        consignee: row.consignee, // 收货人
        contactInformation: row.contactInformation // 收货人联系方式
      }
    },
    // 删除发票
    invoiceDeleteHandle (row) {
      this.$confirm('此操作将永久删除该发票?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.$http
            .post(`/front/consumer/order/payinvoice/delete`, [row.invoiceId])
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return false
              }

              this.getInvoicList()
            })
        })
        .catch(() => {})
    },
    // 关闭发票
    closeInviceHandle () {
      this.invoiceVisible = false
      this.$refs['invoiceForm'].resetFields()
    },
    // 保存发票
    invoiceSaveHandle: debounce(
      function () {
        this.$refs['invoiceForm'].validate(valid => {
          if (!valid) {
            return false
          }
          if (this.invoiceForm.invoiceObjType === '10') {
            this.invoiceForm.invoiceObjId = ''
          } else {
            this.invoiceForm.invoiceObjId = this.params.companyId
          }
          this.invoiceForm.companyId = this.params.companyId
          this.invoiceForm.defaultFlag = this.invoiceForm.flagAdd ? '10' : '20'
          this.$http
            .post(
              `/front/consumer/order/payinvoice/${
                this.invoiceForm.invoiceId ? 'update' : 'save'
              }`,
              this.invoiceForm
            )
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return false
              }
              this.$message.success(res.message)
              this.closeInviceHandle()
              this.getInvoicList()
            })
            .catch(() => {})
        })
      },
      1000,
      { leading: true, trailing: false }
    ),
    // 获取发票列表
    getInvoicList () {
      this.$request
        .get(
          `/front/consumer/order/payinvoice/getUserAllInvoiceList?companyId=${this.params.companyId}`
        )
        .then(res => {
          this.payInvoiceInfoList = res || []
          if (this.dataForm.invoiceInfoId) {
            let invoiceInfo = this.payInvoiceInfoList.find(item => {
              return item.invoiceId === this.dataForm.invoiceInfoId
            })
            if (!invoiceInfo) {
              this.dataForm.invoiceInfoId = ''
            }
          }
          if (!this.dataForm.invoiceInfoId && this.payInvoiceInfoList.length) {
            let invoiceInfo = this.payInvoiceInfoList.find(item => {
              return item.defaultFlag === '10'
            })
            if (invoiceInfo) {
              this.dataForm.invoiceInfoId = invoiceInfo.invoiceId
            } else {
              this.dataForm.invoiceInfoId = ''
              // this.payInvoiceInfoList[0].invoiceId
            }
          }
          if (this.payInvoiceInfoList.length === 0) {
            this.InvoiceActiveInex = 100001
          } else if (
            this.payInvoiceInfoList.length - 1 <
            this.InvoiceActiveInex
          ) {
            this.InvoiceActiveInex = this.payInvoiceInfoList.length - 1
          }
        })
        .catch()
    },
    // 提交订单
    submit: debounce(
      function () {
        if (!this.params.orderAddressId) {
          this.$message.error('请选择地址')
          return
        }
        let orderInvoiceId = ''
        if (this.InvoiceActiveInex !== 100001) {
          orderInvoiceId = this.payInvoiceInfoList[this.InvoiceActiveInex]
            .invoiceId
        }
        if (this.buttonLoading) {
          return false
        }
        this.buttonLoading = true
        let CALLBACK_URL = Cookies.get('CALLBACK_URL')
        let params = {
          orderAddressId: this.params.orderAddressId,
          orderInvoiceId: orderInvoiceId,
          esOrderDetailForms: this.dataJson.commodityDetails,
          callbackUrl: CALLBACK_URL
        }
        this.$http
          .post(`/openapi/punchoutOrder/saveOrder`, params)
          .then(({ data: res }) => {
            if (res.resultCode !== '0') {
              return false
            } else {
              this.bus.$emit('shopCartNum')
              location.href = CALLBACK_URL
            }
          })
          .finally(() => {
            this.buttonLoading = false
          })
      },
      1000,
      { leading: true, trailing: false }
    ),
    // 获取省
    getProvince () {
      this.$http
        .get(`/front/sys/sysProvince/provinceList`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.region = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('获取省份失败')
        })
    },
    // 获取市
    getCity (codeP) {
      return this.$http
        .get(`/front/sys/sysProvince/cityList/${codeP}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            return res.data
          } else {
            this.$message.error(res.msg)
            return []
          }
        })
        .catch(() => {
          this.$message.error('获取城市失败')
        })
    },
    // 获取区
    getArea (codeC) {
      return this.$http
        .get(`/front/sys/sysProvince/areaList/${codeC}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            const leafData = res.data.map((item) => {
              return {
                ...item,
                leaf: true
              }
            })
            return leafData
          } else {
            this.$message.error(res.msg)
            return []
          }
        })
        .catch(() => {
          this.$message.error('获取区域失败')
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.create_order {
  background: #fff;
  padding: 30px;
  .order_body {
    width: 907px;
    margin: 0 auto;
    .margin-top {
      margin-top: 20px;
    }
    .left-margin {
      margin-left: 30px;
    }
    /deep/ input[type='radio'] {
      width: 14px;
      height: 14px;
      background: #fff;
      -webkit-appearance: none;
      -moz-appearance: none;
      border: 1px solid #dcdfe6;
      margin-right: 10px;
      cursor: pointer;
    }
    /deep/input[type='radio']:checked {
      background: url('./../../../assets/img/order/selecta.png');
      background-size: cover;
      border: none;
    }
    /deep/ input[type='radio']:disabled {
      background-color: #ebebeb;
      cursor: default;
    }
    .addBut {
      display: inline-block;
      width: 130px;
      height: 40px;
      box-sizing: border-box;
      border: 1px solid #1d65a8;
      color: #1d65a8;
      line-height: 40px;
      text-align: center;
      font-size: 16px;
      user-select: none;
      cursor: pointer;
      z-index: 666;
    }
    .addressList_oreder {
      padding-top: 20px;
      width: 1000px;
      margin: 0 auto;
      color: #333333;
      .addTitle_box {
        height: 44px;
        .addTitle_label {
          font-size: 20px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          line-height: 20px;
        }
        .addTitle_btn {
          i {
            margin-right: 6px;
          }
          user-select: none;
          font-size: 14px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          color: #1d65a8;
          line-height: 20px;
          cursor: pointer;
          margin-left: 10px;
        }
      }
      .addList_box {
        padding: 16px 20px;
        border-bottom: solid 1px #eeeeee;
        .addList_left {
          width: 750px;
          cursor: pointer;
          .addList_left_title {
            font-size: 14px;
            color: #333333;
            line-height: 20px;
            height: 30px;
            .addList_left_name {
              margin-right: 10px;
              font-weight: 500;
            }
            .addList_left_phone {
              margin-right: 10px;
              font-weight: 500;
            }
            .addList_left_tag {
              margin-top: 2px;
              display: block;
              width: 30px;
              font-weight: 300;
              height: 17px;
              background: #1d65a8;
              color: #fff;
              line-height: 17px;
              text-align: center;
              font-size: 12px;
            }
          }
          .addList_left_address {
            i {
              color: #666666;
              margin-right: 6px;
              line-height: 20px;
            }
            font-size: 12px;
            font-weight: 400;
            text-align: left;
            color: #333333;
            line-height: 20px;
          }
        }
        .addList_right {
          display: flex;
          align-content: center;
          /deep/ span {
            font-weight: 400 !important;
          }
          // width: 250px;
        }
      }
      .addList_box_active {
        border: 1px solid #b6d6ff;
        background: url('../../../assets/img/punchout/bingo.png') no-repeat
          right bottom;
        background-color: #e5f0ff;
      }
    }
    .downloadContract {
      padding-left: 80px;
      margin-top: 15px;
      .checkContract {
        margin-right: 20px;
        height: 36px;
        line-height: 36px;
        color: #1d65a8;
        cursor: pointer;
      }
    }
    .invoice_order {
      width: 1000px;
      margin: 32px auto;
      .invoice_title {
        font-size: 20px;
        font-weight: 500;
        color: #333333;
        height: 46px;
        .invoice_title_label {
          font-size: 20px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          line-height: 20px;
        }
        .invoice_title_btn {
          i {
            margin-right: 6px;
          }
          user-select: none;
          font-size: 14px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          color: #1d65a8;
          line-height: 20px;
          cursor: pointer;
          margin-left: 10px;
        }
      }
      .invoice_list_box {
        .invoice_list_item {
          padding: 10px 20px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
          border: 1px solid #dddddd;
          margin-right: 16px;
          margin-bottom: 20px;
          display: table-cell;
          cursor: pointer;
        }
        .invoice_list_item_active {
          border: 1px solid #2e88ff;
          background: url('../../../assets/img/punchout/bingo.png') no-repeat
            right bottom;
          background-color: #e5f0ff;
          background-size: 20px 20px;
        }
      }
      .invoice_Info {
        padding: 30px;
        background: #f9f9f9;
        .invoice_Info_left {
          width: 740px;
          .invoice_Info_item {
            line-height: 20px;
            margin-bottom: 20px;
            color: #333333;
            width: 320px;
            padding-right: 10px;
            .invoice_item_label {
              width: 90px;
            }
            .invoice_item_content {
              width: 220px;
            }
          }
        }
        .invoice_Info_right {
          width: 200px;
          .el-button {
            display: block;
            font-size: 14px;
            margin: 0;
          }
        }
      }
    }
    .goods_box {
      width: 1000px;
      .goods_title {
        font-size: 20px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        line-height: 20px;
        height: 46px;
      }
      .submit_btn {
        width: 100%;
        height: 64px;
        line-height: 64px;
        padding: 0;
      }
      .goods_info {
        align-content: center;
        .img-box {
          width: 80px;
          img {
            width: 100%;
          }
        }
        .goods_info_title {
          width: 290px;
        }
      }
    }
    .discount {
      text-decoration: line-through;
      color: #aaaaaa;
    }
    .not-in-distribution {
      width: 320px;
      padding: 9px 43px;
      line-height: 22px;
      border: none;
      color: #fff;
      margin: 0 auto;
      cursor: not-allowed;
      background: #eee;
      color: #999;
    }
    .save-but {
      background: #1d65a8;
      width: 320px;
      padding: 9px 43px;
      line-height: 22px;
      border: none;
      color: #fff;
      margin: 0 auto;
      cursor: pointer;
    }
    .deliveryArea {
      display: inline-block;
      border: 1px solid red;
      padding: 3px 5px;
      border-radius: 10px;
      color: red;
    }
    .default-flag {
      display: inline-block;
      width: 35px;
      height: 20px;
      line-height: 20px;
      background: #1d65a8;
      color: #ffffff;
      font-weight: normal;
      font-size: 12px;
      text-align: center;
      margin-left: 20px;
    }
  }
  .last_row {
    display: flex;
    justify-content: space-between;
    font-size: 20px;
  }
}
.desc {
  font-size: 12px;
  font-weight: 400;
  color: #666666;
  line-height: 17px;
  text-align: center;
  padding: 15px 0;
}
.addArea {
  width: 1100px;
  // height: 506px;
  background: #ffffff;
  padding-left: 23px;
  padding-right: 42px;
  .addTitle {
    height: 80px;
    line-height: 80px;
    font-size: 22px;
    color: #333333;
    text-indent: 8px;
    border-bottom: 1px solid #eeeeee;
  }
  .add_form {
    .input_width {
      width: 250px;
    }
    .last_row {
      display: flex;
      justify-content: space-between;
    }
    .saveAdd {
      width: 150px;
      height: 40px;
      background: #1d65a8;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
      margin-top: 30px;
      margin-left: 859px;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
  }
}
</style>
